import { NgModule } from '@angular/core';
import { SmtpfComponent } from './smtpf/smtpf.component';
import { ImprintComponent } from './imprint/imprint.component';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { ContactComponent } from './contact/contact.component';
import { SharedModule } from '../shared/shared.module';
import { ImprintModule } from '@smtpf/imprint';

@NgModule({
  declarations: [
    SmtpfComponent,
    ImprintComponent,
    ContactComponent
  ],
  imports: [CommonModule, MatTooltipModule, MatButtonModule, SharedModule, ImprintModule],
  exports: []
})

export class PagesModule {
}
